import { Splide } from "@splidejs/splide";


// .js-mapSlider と .js-mapNumber{N} の連動 + .js-lightingSlider
const init = () => {
  const sliderEl = document.querySelector(".js-mapSlider");
  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: "loop",
      perPage: 1,
      pagination: true,
      arrows: true,
    });

    const mapNumbers = document.querySelectorAll("[class*='js-mapNumber']");

    const updateCur = (index) => {
      mapNumbers.forEach((el) => el.classList.remove("cur"));
      const target = document.querySelector(".js-mapNumber" + (index + 1));
      if (target) target.classList.add("cur");
    };

    mapNumbers.forEach((el) => {
      el.addEventListener("click", () => {
        const match = el.className.match(/js-mapNumber(\d+)/);
        if (!match) return;
        const index = parseInt(match[1], 10) - 1;
        splide.go(index);
        updateCur(index);
      });
    });

    splide.on("moved", (newIndex) => {
      updateCur(newIndex);
    });

    splide.mount();

    updateCur(splide.index);
  }

  const lightingSliderEl = document.querySelector(".js-lightingSlider");
  if (lightingSliderEl) {
    const lightingSplide = new Splide(lightingSliderEl, {
      type: "loop",
      perPage: 1,
      pagination: true,
      arrows: true,
    });
    lightingSplide.mount();
  }
};

export default init;
